import { render, staticRenderFns } from "./Style.vue?vue&type=template&id=53b91af4&"
import script from "./Style.ts?vue&type=script&lang=ts&"
export * from "./Style.ts?vue&type=script&lang=ts&"
import style0 from "./Style.vue?vue&type=style&index=0&id=53b91af4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports